import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {IS_BROWSER} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/injectiontokens";
import {DOCUMENT} from "@angular/common";
import {WebFlowContainerComponent} from "../webflowcontainer.component";
import {CurrenciesPopupComponent} from "../../parts/currenciespopup/currenciespopup.component";
import {CryptosPopupComponent} from "../../parts/cryptopopup/cryptospopup.component";
import {Router} from "@angular/router";
import {ExchangeService} from "@aparraga/ahoracrypto-client-common/src/app/common/exchange/exchange.service";
import {
  PurchaseFlowHelperService
} from "@aparraga/ahoracrypto-client-common/src/app/common/flowhelpers/purchaseflowhelper.service";
import {
  RegistrationFlowHelperService
} from "@aparraga/ahoracrypto-client-common/src/app/common/flowhelpers/registrationflowhelper.service";
import {StringUtils} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/stringutils";
import {Subscription} from "rxjs";
import {NavigationService} from "@aparraga/ahoracrypto-client-common/src/app/common/navigation/navigation.service";
import {JsLoaderService} from "../../jsloader/jsloader.service";


@Component({
    selector: 'cryptoform2',
    templateUrl: './cryptoform2.component.html',
    styleUrls: [
        './css/normalize.scss',
        './css/webflow.scss',
        './css/ahoracryptoes-54c43cd2d8f-d4fafc0e38e25.webflow.scss',
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CryptoForm2Component extends WebFlowContainerComponent implements AfterViewInit {

  protected override webflowPage = '661c0888a66a1feeabadb6b4';
  protected override webflowSite = '661c0888a66a1feeabadb6b3';
  protected override resources = [
    '/assets/landings/landing2/js/webflow.js',
  ]

  protected subscriptions: Subscription[] = new Array<Subscription>();
  public currentCryptoExchangeRate: number;
  public referral: string;
  public offerText: string;
  public offerTooltipText: string;
  public initialCryptoExchangeRateFormatted: string;
  public showOffer = false;
  public countUpOptions = {
    decimalPlaces: 12
  }

  public title = 1;

  @Input('action') action = 'buy';

  @ViewChild('currenciespopup') currenciespopup: CurrenciesPopupComponent;
  @ViewChild('cryptospopup') cryptospopup: CryptosPopupComponent;

  @ViewChild('botwarning') public botwarning: ElementRef<HTMLElement>;

  public constructor(
    @Inject(IS_BROWSER) protected override isBrowser: boolean,
    @Inject(DOCUMENT) protected override document: Document,
    protected router: Router,
    protected exchangeService: ExchangeService,
    private renderer: Renderer2,
    protected override jsLoaderService: JsLoaderService,
    protected navigationService: NavigationService,
    public purchaseFlowHelperService: PurchaseFlowHelperService,
    public registrationFlowHelperService: RegistrationFlowHelperService,
    protected stringUtils: StringUtils)
  {
    super();

    this.purchaseFlowHelperService.buildForm();

    this.purchaseFlowHelperService.fieldToValidate = ['currencyAmount', 'cryptoAmount'];

    let exchangePrice = this.exchangeService.getExchangePrice(this.purchaseFlowHelperService.selectedCrypto, this.purchaseFlowHelperService.selectedCurrency);
    if(exchangePrice != null) {
      this.currentCryptoExchangeRate = exchangePrice.price;
      this.countUpOptions['startVal'] = this.currentCryptoExchangeRate;
      this.initialCryptoExchangeRateFormatted = this.stringUtils.formatCurrency(this.currentCryptoExchangeRate);
    }
    this.countUpOptions['formattingFn'] = this.stringUtils.formatCurrency.bind(this.stringUtils);

    this.subscriptions.push(this.exchangeService.exchangePricesSubject$.subscribe(exchangeRates => {
      this.updateCryptoInformation();
    }));

    this.purchaseFlowHelperService.onCurrencySelected$.subscribe(() => {
      this.updateCryptoInformation();
    });
    this.purchaseFlowHelperService.onCryptoSelected$.subscribe(() => {
      this.updateCryptoInformation();
    });

  }


  ngAfterViewInit() {
    this.configureWebflow();
    this.referral = this.navigationService.getReferral();
    if(this.referral != null) {
      this.updateOfferTooltipText();
      this.showOffer = true;
    }
    this.purchaseFlowHelperService.currenciespopup = this.currenciespopup;
    this.purchaseFlowHelperService.cryptospopup = this.cryptospopup;

  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public onSubmit() {
    if(this.action == 'buy') {
      if (this.purchaseFlowHelperService.isValidForm()) {
        this.purchaseFlowHelperService.updateCart().then(() => {
          this.router.navigate(['/purchaseflow']);
        });
      }
    }
    else {
      this.router.navigate(['/salesflow']);
    }
  }

  public onCurrencySelected(event) {
    this.purchaseFlowHelperService.selectCurrency(event);
    this.updateOfferTooltipText();
  }

  public updateOfferTooltipText() {
    this.offerText = this.stringUtils.formatCurrency(5, false) + ' gratis';
    this.offerTooltipText = this.stringUtils.formatCurrency(5, false) + ' gratis por compras superiores a ' + this.stringUtils.formatCurrency(100, false) + '<br />Por usar el link de referido de ' + this.referral;
  }

  protected updateCryptoInformation() {
    this.currentCryptoExchangeRate = this.exchangeService.calculateExchange(this.purchaseFlowHelperService.selectedCrypto, 1, this.purchaseFlowHelperService.selectedCurrency);
  }

}
